import React from 'react';
import ReactDOM from 'react-dom';

import HyperDX from '@hyperdx/browser';

import App from './app';
import { IS_PROD, HYPERDX_APIKEY } from './constant/config';

if (IS_PROD) {
  HyperDX.init({
    apiKey: HYPERDX_APIKEY,
    service: 'steamup/web',

    // Set to link traces from frontend to backend requests
    tracePropagationTargets: [/localhost, www.steamup.academy/i],

    consoleCapture: true, // Capture console logs (default false)
    // advancedNetworkCapture: true, // Capture full HTTP request/response headers and bodies (default false)
  });
}

ReactDOM.render((
  <React.StrictMode>
    <App />
  </React.StrictMode>
), document.getElementById('root'));
